import {createGalleryStore} from "@/store/campaignGallery";
import {create} from "@/store/createStore";
import type {TCampaignType} from "@/store/types";
import {devtools} from "zustand/middleware";
import {immer} from "zustand/middleware/immer";

type TStoreReturnType = ReturnType<typeof createGalleryStore>;

type TState = {
  active: TCampaignType;
  instagram: TStoreReturnType;
  tiktok: TStoreReturnType;
  ugc: TStoreReturnType;
  selectActiveStore(): TState[TCampaignType];
  setActiveStore(key: TCampaignType): void;
};

const useFavouriteContentStore = create<TState>()(
  immer(
    devtools(
      (set, get) => ({
        active: "instagram",
        instagram: createGalleryStore(),
        tiktok: createGalleryStore(),
        ugc: createGalleryStore(),
        selectActiveStore: () => get()[get().active],
        setActiveStore: key => {
          const prev = get().active;

          // Reset the previous store
          get()[prev].getState().reset();
          get()[prev].getState().setFilters("media_product_type", null);

          set(
            state => {
              state.active = key;
            },
            false,
            "useFavouriteContentStore/setActiveStore",
          );
        },
      }),
      {name: "useFavouriteContentStore"},
    ),
  ),
);

export {useFavouriteContentStore};
